import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SidebarProvider } from './contexts/SidebarContext';
import LoadingSpinner from './components/LoadingSpinner';
import LandingPage from './pages/LandingPage'; // Keep this as regular import
import './styles/base.scss';

// Lazy load only the authenticated pages
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const InvoicesPage = React.lazy(() => import('./pages/InvoicesPage'));
const BillsPage = React.lazy(() => import('./pages/BillsPage'));
const PaymentsPage = React.lazy(() => import('./pages/PaymentsPage'));
const InformationPage = React.lazy(() => import('./pages/InformationPage'));

const AppContent: React.FC = () => {
  const { isAuthenticated } = useAuth();

  // If not logged in, show landing page (no lazy loading for first page)
  if (!isAuthenticated) {
    return <LandingPage />;
  }

  // If logged in, show router with protected routes (lazy loaded)
  return (
    <SidebarProvider>
      <Router>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            <Route path="/invoices" element={<InvoicesPage />} />
            <Route path="/bills" element={<BillsPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/information" element={<InformationPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </Router>
    </SidebarProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;